import React, { useEffect, useRef, useState } from 'react';
import { Link as MuiLink, Chip, Grid, Toolbar, Dialog, DialogContent, Typography, Button, Card, CardContent, ListItem, ListItemText, List, Table, TableHead, TableRow, TableCell, TableBody, MenuItem, DialogActions, Checkbox, TextField as MuiTextField, LinearProgress } from '@mui/material';
import EventTable from '../../components/event_table';
import EnhancedTable from '../../components/table';
import TextField from '../../components/text_field';
import SelectField from '../../components/select_field';
import CheckboxField from '../../components/checkbox';
import FastSelect from '../../components/fast_suggest_field';
import AutoComplete from '../../components/suggest_field';
import Config from '../../config';
import { getCompanyNames, readFileAsync } from '../../helpers';
import {Warning} from "@mui/icons-material";
import Moment from 'react-moment';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import axios from 'axios';
import { Form as FormBase, Field as FieldBase } from 'react-final-form';
import ConfirmDialog from '../../components/confirm_dialog';
import ErrorDialog from '../../components/error_dialog';
import DownloadButton from '../../components/download_button';
import Helper from '../../helpers';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';
import { Link } from 'react-router-dom';
import DropZone from '../files/dropzone';
import Auth from '../../auth';
import isEqual from 'lodash.isequal';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ContentLoader from '../../components/content_loader';

// react-final-form's Form/Field generics don't line up with this file's loose
// value shapes; cast to any at the import boundary (established pattern, see
// reports.tsx/scorecards.tsx).
const Form: any = FormBase;
const Field: any = FieldBase;

const vftpAddress = Config.production ? 'vftp.logicbroker.com' : 'vftp-stage.logicbroker.com';

const protocols = [
    {value: 'FTP', label: 'FTP'},
    {value: 'FTPS', label: 'FTPS'},
    {value: 'SFTP', label: 'SFTP'},
    {value: 'HTTP', label: 'AS2 (HTTP)'},
    {value: 'HTTPS', label: 'AS2 (HTTPS)'}
];

const lbCertificates = [
    "LOGICBROKERAS2",
    "LOGICTECAS2",
    "STAGELOGICBROKERAS2",
    "STAGELOGICTECAS2"
];

const encryptionAlgs = [
    {value:"AESCBC128", label:"AES128"},
    {value:"AESCBC192", label:"AES192"},
    {value:"AESCBC256", label:"AES256"}
];

const signatureAlgs = [
    {value:"sha-256", label:"SHA-256"},
    {value:"sha-512", label:"SHA-512"}
];

const winscpFormatter = (config: any, prop: string) => {
    if(!config){
        return;
    }
    let str = config[prop];
    if(!str){
        return;
    }
    let params = getParamsFromUrl(str);
    config[prop] = params;
    return config;
}

const winscpPostProcess = (config: any, prop: string) => {
    if(!config){
        return;
    }
    let obj = config[prop];
    if(!obj){
        return;
    }
    let creds: any = {};
    creds.Username = config[prop].Username;
    creds.Password = config[prop].Password;
    creds.Address = config[prop].Address;
    creds.Protocol = config[prop].Protocol;
    let keys = Object.keys(creds);
    let allNull = true;
    for (let i = 0; i < keys.length; i++) {
        if (creds[keys[i]] === null || creds[keys[i]] === undefined) {
            creds[keys[i]] = "";
        }
        if (creds[keys[i]] !== "") {
            allNull = false;
        }
    }
    if (!allNull) {
        let userPass = "";
        if(creds.Username || creds.Password){
            userPass = encodeURIComponent(creds.Username) + ":" + encodeURIComponent(creds.Password) + "@";
        }
        config[prop] = creds.Protocol.toLowerCase() + "://" + userPass + creds.Address;
    } else {
        config[prop] = null;
    }
    return config;
}

const getParamsFromUrl = (str: any) => {
    let ret: any = {Username: null, Password: null, Address: null, Protocol: null};
    if (typeof str !== "string") {
        return ret;
    }
    let col = str.indexOf("://");
    if (col === 0) {
        str = str.substring(3);
    }
    else if (col > 0) {
        ret.Protocol = str.substring(0, col).toUpperCase();
        str = str.substring(col + 3);
    }
    let at = str.indexOf("@");
    if (at === 0) {
        str = str.substring(1);
    }
    else if (at > 0) {
        let userPass = str.substring(0, at);
        let split = userPass.split(":");
        ret.Username = decodeURIComponent(split[0]);
        if (split.length > 1) {
            ret.Password = decodeURIComponent(split[1]);
        }
        str = str.substring(at + 1);
    }
    ret.Address = str;
    return ret;
}

const validateWinscpAddress = (prefix: string, field: string) => (value: any, allValues: any) => {
    let address = getValue(allValues, prefix + 'Address');
    if(address && field === 'Address' && address.match(/^[A-Za-z0-9]*:\/\//)){
        return "Do not put the protocol in the address field."
    }
    let protocol = getValue(allValues, prefix + 'Protocol');
    if((address || protocol) && !value){
        return "Required.";
    }
}

const getValue = (allValues: any, path: string): any => {
    let split = path.split(".");
    let field = split[0];
    if(field.indexOf("[") > -1){
        let indexSplit = field.split('[');
        let index = parseInt(indexSplit[1].split("]")[0]);
        field = indexSplit[0];
        if(split.length > 1 && allValues[field] && allValues[field][index]){
            return getValue(allValues[field][index], split.slice(1).join("."));
        }
    }
    if(split.length > 1 && allValues[field]){
        return getValue(allValues[field], split.slice(1).join("."));
    }
    return allValues[path];
}

const documentTypes = [
    {value: 'POAck', label: 'Acknowledgement'},
    {value: 'Order', label: 'Order'},
    {value: 'Product', label: 'Product'},
    {value: 'Inventory', label: 'Inventory'},
    {value: 'Invoice', label: 'Invoice'},
    {value: 'Return', label: 'Return'},
    {value: 'AdvanceShipmentNotice', label: 'Shipment'},
    {value: 'FuncAck', label: 'FuncAck'},
];

const numberFormat = (v: any) => {
    if(v === undefined){
        return null;
    }
    let p = parseInt(v);
    if(!isNaN(p)){
        return p;
    }
    return v;
}

const DefaultChip = () => {
    return <Chip label='Default' style={{backgroundColor: '#275E7A', color: 'white'}}/>;
}

type PartnerSelectorProps = {
    name: string;
    options: any[];
    style?: React.CSSProperties;
    [key: string]: any;
};

const PartnerSelector = (props: PartnerSelectorProps) => {
    let {name, options, style, ...otherProps} = props;
    return <WrappedField label='Partner'>
        <Field style={{flex: '1', ...style}} component={FastSelect} format={numberFormat} parse={numberFormat} options={options} placeholder='Any Partner' name={name} {...otherProps}/>
    </WrappedField>;
}

type DocumentTypeSelectorProps = {
    name: string;
    style?: React.CSSProperties;
    [key: string]: any;
};

const DocumentTypeSelector = (props: DocumentTypeSelectorProps) => {
    let {name, style, ...otherProps} = props;
    return <WrappedField label='Document Type'>
        <Field style={{flex: '1', ...style}} component={FastSelect} options={documentTypes} placeholder='Any Type' name={name} {...otherProps}/>
    </WrappedField>;
}

type WrappedFieldProps = {
    label?: React.ReactNode;
    children?: React.ReactNode;
    innerStyle?: React.CSSProperties;
    style?: React.CSSProperties;
};

const WrappedField = (props: WrappedFieldProps) => {
    let {label, children, innerStyle, style} = props;
    return <div style={{display: "flex", minHeight: "2em", alignItems: "center", flex: 1, ...style}}>
        <div style={{width: "11em", display: "inline-block", fontWeight: "bold", fontSize: '14px'}}>{label}</div>
        <div style={{display: "inline-flex", flex: 1, ...innerStyle}}>{children}</div>
    </div>
}

type NetworkLocationsProps = {
    save: (property: string, entry: any, index?: number | null) => Promise<boolean | undefined>;
    locations: any[];
    partners: any[];
    testLocation: (values: any) => void;
    certificates?: any[];
    vftpPassword?: string;
    vftpGeneratePassword?: () => void;
};

type NetworkLocationsState = {
    certificates: any[];
    loaded: boolean;
    showAdd: boolean;
    showEdit: boolean;
    showConfirm: boolean;
    showError: boolean;
    errorMessage: string;
    confirmMessage?: string;
    confirmAction?: () => void;
    formIndex?: number | null;
    formValue?: any;
};

const NetworkLocations = (props: NetworkLocationsProps) => {
    const [state, setState] = useState<NetworkLocationsState>({certificates: [], loaded: true, showAdd: false, showEdit: false, showConfirm: false, showError: false, errorMessage: ''});
    const setStatePartial = (partial: Partial<NetworkLocationsState>) => setState(prev => ({...prev, ...partial}));

    const remove = async (fields: any, index: number, confirm?: boolean) => {
        if(!confirm){
            setStatePartial({showConfirm: true, confirmMessage: 'Are you sure you want to remove this location?', confirmAction: () => remove(fields, index, true)});
            return;
        }
        await props.save('NetworkLocations', null, index);
    }
    const saveLocation = async (loc: any) => {
        let saved = await props.save('NetworkLocations', loc, state.formIndex);
        if(saved){
            setStatePartial({showEdit: false});
        }
    }
    const format = (destination: any) => {
        let address = (destination || {}).Address;
        let protocol = (destination || {}).Protocol;
        if(!address && !protocol){
            return vftpAddress;
        }
        return address;
    }

    let {locations, partners, testLocation, certificates, vftpPassword, vftpGeneratePassword} = props;
    let locationDialogProps = {testLocation, partners, certificates: certificates || [], vftpPassword, vftpGeneratePassword};
    return <Grid size={12}>
    <Card>
        <Toolbar className='lbtoolbar'>My EDI Connection</Toolbar>
        <div style={{padding: '1em', textAlign: 'left'}}>
            <Button variant='outlined' onClick={() => {setStatePartial({showEdit: true, formIndex: null, formValue: {Enabled: true}})}}>Add a connection override</Button>
        </div>
        <Table>
        <TableHead>
            <TableRow>
                <TableCell style={{minWidth: '15em', textAlign: 'center', padding: 0}}>Connection method</TableCell>
                <TableCell style={{textAlign: 'center', padding: 0}}>Connection address</TableCell>
                <TableCell style={{minWidth: '10em', textAlign: 'center', padding: 0}}>Partner</TableCell>
                <TableCell style={{minWidth: '10em', textAlign: 'center', padding: 0}}>Document type</TableCell>
                <TableCell style={{minWidth: '4em', textAlign: 'center', padding: 0}}>Enabled</TableCell>
                <TableCell style={{width: '8em', minWidth: '8em', textAlign: 'center', padding: 0}}></TableCell>
                <TableCell style={{width: '195px', minWidth: '195px', padding: 0}}></TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
        {state.loaded && locations.map((loc: any, index: number) => (
            <TableRow key={index}>
                <TableCell style={{textAlign: 'center', padding: 0, maxWidth: '0px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}>{(protocols.find(r => r.value === (loc.Destination || {}).Protocol) || {}).label || 'Logicbroker-hosted SFTP'}</TableCell>
                <TableCell style={{textAlign: 'center', padding: 0, maxWidth: '0px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}>{format(loc.Destination)}</TableCell>
                <TableCell style={{textAlign: 'center', padding: 0, maxWidth: '0px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}>{(props.partners.find((r: any) => r.value === Number(loc.PartnerCoId)) || {}).label || loc.PartnerCoId || 'Any Partner'}</TableCell>
                <TableCell style={{textAlign: 'center', padding: 0, maxWidth: '0px', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis'}}>{(documentTypes.find(r => r.value === loc.DocumentType) || {}).label || 'Any Type'}</TableCell>
                <TableCell style={{textAlign: 'center', padding: 0}}><Checkbox style={{pointerEvents: 'none'}} checked={loc.Enabled || false}/></TableCell>
                <TableCell style={{textAlign: 'center', padding: 0}}>{loc.Default ? <DefaultChip/> : ''}</TableCell>
                <TableCell style={{textAlign: 'center', padding: 0}}>
                    <div>
                        <Button variant='outlined' style={{marginRight: '1em'}} onClick={() => setStatePartial({showEdit: true, formIndex: index, formValue: loc})}>Edit</Button>
                        <Button variant='outlined' disabled={loc.Default} onClick={() => remove(loc, index)}>Remove</Button>
                    </div>
                </TableCell>
            </TableRow>
        ))}
        </TableBody>
    </Table>
    {locations.length === 0 && <div style={{marginTop: '0.5em'}}><Typography>There are no outbound network locations.</Typography></div>}
    </Card>
    <LocationDialog {...locationDialogProps} open={state.showEdit} onClose={() => setStatePartial({showEdit: false})} onChange={saveLocation} value={state.formValue}/>
    <ErrorDialog open={state.showError} message={state.errorMessage} onClose={() => setStatePartial({showError: false})}/>
    <ConfirmDialog open={state.showConfirm} onClose={() => setStatePartial({showConfirm: false})} message={state.confirmMessage} onConfirm={state.confirmAction}/>
</Grid>;
}

type LocationDialogProps = {
    value: any;
    open: boolean;
    onClose: () => void;
    partners: any[];
    certificates: any[];
    testLocation: (values: any) => void;
    onChange: (values: any) => void;
    vftpPassword?: string;
    vftpGeneratePassword?: () => void;
};

const LocationDialog = (props: LocationDialogProps) => {
    const [showAdvancedState, setShowAdvancedState] = useState(false);
    const prevOpen = useRef(props.open);
    useEffect(() => {
        if(!prevOpen.current && props.open){
            setShowAdvancedState(false);
        }
        prevOpen.current = props.open;
    }, [props.open]);

    const isFtp = (values: any) => {
        return values.Destination && (values.Destination.Protocol === 'FTP' || values.Destination.Protocol === 'FTPS' || values.Destination.Protocol === 'SFTP');
    }
    const isVftp = (values: any) => {
        return !values.Destination || !values.Destination.Protocol;
    }
    const isAs2 = (values: any) => {
        return values.Destination && (values.Destination.Protocol === 'HTTP' || values.Destination.Protocol === 'HTTPS');
    }
    const toggleAdvanced = (e: React.MouseEvent) => {
        e.preventDefault();
        setShowAdvancedState(prev => !prev);
    }

    let {value, open, onClose, partners, certificates, testLocation, onChange, vftpPassword, vftpGeneratePassword} = props;
    let advancedFieldsPopulated = !(!(value && (value.PartnerCoId || value.DocumentType || value.DestinationFileMask || value.As2EncryptionAlgorithm || value.As2SignatureAlgorithm)));
    let showAdvanced = showAdvancedState || advancedFieldsPopulated;
    return <Dialog maxWidth="lg" open={open} onClose={onClose}>
        <Toolbar className='lbtoolbar'>My EDI Connection</Toolbar>
        <Form onSubmit={onChange} initialValues={value} render={({ handleSubmit, pristine, invalid, values }: any) => (
          <form autoComplete='off' onSubmit={handleSubmit}>
        <DialogContent>
            <Typography style={{marginBottom: '0.5rem'}}>These settings control your documents from Logicbroker. Select your preferred connection method to add your EDI connection details.</Typography>
            <div style={{flexDirection: 'row', display: 'flex', gap: '1em'}}>
            <div style={{flex: '1 1 55%'}}>
                <Typography variant='h6'>My connection details</Typography>
                {!isVftp(values) && <>
                    {showAdvanced && <PartnerSelector name='PartnerCoId' options={partners}/>}
                    {showAdvanced && <DocumentTypeSelector name='DocumentType'/>}
                    <WrappedField label='Enabled'>
                        <Field component={CheckboxField} type='checkbox' name='Enabled'/>
                    </WrappedField>
                </>}
                <WrappedField label='Connection method'>
                    <Field formControlProps={{style: {flex: 1, textAlign: 'left'}}} displayEmpty component={SelectField} validate={validateWinscpAddress('Destination.', 'Protocol')} validateFields={['Destination.Address']} name='Destination.Protocol'>
                        <MenuItem value="">Logicbroker-hosted SFTP</MenuItem>
                        {protocols.map(r => <MenuItem key={r.value} value={r.value}>{r.label}</MenuItem>)}
                    </Field>
                </WrappedField>
                {isVftp(values) && <>
                    <WrappedField label='Username'>
                        <MuiTextField style={{flex: '1'}} disabled value={Auth.getAccountNumber().toString()}/>
                    </WrappedField>
                    <WrappedField label='Password'>
                        {vftpPassword ? <MuiTextField style={{flex: '1'}} disabled value={vftpPassword}/> : <DownloadButton variant='outlined' color='primary' style={{padding: 0}} onClick={vftpGeneratePassword}>Generate</DownloadButton>}
                    </WrappedField>
                </>}
                <WrappedField label='Address URL*' style={{display: isVftp(values) ? 'none' : 'flex'}}>
                    <Field component={TextField} format={(v: any) => v ? v.trim() : v} formatOnBlur validate={validateWinscpAddress('Destination.', 'Address')} validateFields={['Destination.Protocol']} style={{flex: 1}} name='Destination.Address'/>
                </WrappedField>
                {isFtp(values) && <>
                <WrappedField label='Username*'>
                    <Field style={{flex: 1}} name='Destination.Username' validate={(v: any) => !v ? 'Required.' : null} format={(v: any) => v ? v.trim() : v} formatOnBlur component={TextField}/>
                </WrappedField>
                <WrappedField label='Password*'>
                <Field component={TextField} style={{flex: 1}} name='Destination.Password' validate={(v: any) => !v ? 'Required.' : null} type='password' inputProps={{
                        onFocus: (e: any) => {if(e.currentTarget.type === "password"){e.currentTarget.type = "text";}},
                        onBlur: (e: any) => {e.currentTarget.type = "password";}}}/>
                </WrappedField>
                </>}
                {!isVftp(values) && showAdvanced && <WrappedField label='File Mask'>
                    <Field style={{flex: 1}} name='DestinationFileMask' format={(v: any) => v ? v.trim() : v} formatOnBlur component={TextField}/>
                </WrappedField>}
                {isAs2(values) &&
                <>
                {showAdvanced && <WrappedField label='AS2 Encryption'>
                    <Field formControlProps={{style: {flex: 1, textAlign: 'left'}}} displayEmpty shrink={true} component={SelectField} name='As2EncryptionAlgorithm'>
                        <MenuItem value="">3DES (Default)</MenuItem>
                        {encryptionAlgs.map(r => <MenuItem key={r.value} value={r.value}>{r.label}</MenuItem>)}
                    </Field>
                </WrappedField>}
                {showAdvanced && <WrappedField label='AS2 Signature'>
                    <Field formControlProps={{style: {flex: 1, textAlign: 'left'}}} displayEmpty shrink={true} component={SelectField} name='As2SignatureAlgorithm'>
                        <MenuItem value="">SHA-1 (Default)</MenuItem>
                        {signatureAlgs.map(r => <MenuItem key={r.value} value={r.value}>{r.label}</MenuItem>)}
                    </Field>
                </WrappedField>}
                <WrappedField label={`Logicbroker's AS2 ID*`}>
                    <Field formControlProps={{style: {flex: 1, textAlign: 'left'}}} validate={(v: any) => !v ? 'Required.' : null} shrink={true} formatOnBlur displayEmpty component={AutoComplete} alwaysShowError name='As2SenderId' options={lbCertificates.map(r => ({value: r, label: r}))}/>
                </WrappedField>
                <WrappedField label='My AS2 ID*'>
                    <Field style={{flex: 1}} formatOnBlur validate={(v: any) => !v ? 'Required.' : null} format={(v: any) => v ? v.trim() : v} name='As2ReceiverId' component={TextField}/>
                </WrappedField>
                <WrappedField label='AS2 Certificate*'>
                    <Field style={{flex: 1}} name='As2ReceiverCertificate' validate={(v: any) => !v ? 'Required, upload from the certificates table.' : null} formatOnBlur component={FastSelect} options={certificates}/>
                </WrappedField>
                </>}
                {!isVftp(values) && <>
                    <MuiLink component='button' {...({disabled: advancedFieldsPopulated} as any)} onClick={toggleAdvanced} style={{fontSize: '0.875rem'}}>
                        {showAdvanced ? <>Hide advanced options <ExpandLessIcon style={{verticalAlign: 'middle'}}/></> : <>Show advanced options <ExpandMoreIcon style={{verticalAlign: 'middle'}}/></>}
                    </MuiLink>
                </>}
            </div>
            {!isFtp(values) && <div style={{flex: '1 1 40%'}}>
                <Typography variant='h6'>Logicbroker connection details</Typography>
                {isAs2(values) && <>
                <WrappedField label='Address'>
                    <MuiTextField style={{flex: '1'}} disabled value={Config.api.split('://')[1] + '/as2'}/>
                </WrappedField>
                <WrappedField label='Certificate'>
                    <DownloadButton variant='text' color='primary' style={{padding: 0}} href={Config.api + `/odata/Company/Functions.DownloadAs2Certificate?id=-1`} fileName='logicbroker_as2.cer'>Download</DownloadButton>
                </WrappedField>
                <WrappedField label='Sender IP Address'>
                    <MuiTextField style={{flex: '1'}} disabled value='23.101.133.17'/>
                </WrappedField>
                <WrappedField label='AS2 Port'>
                    <MuiTextField style={{flex: '1'}} disabled value='80 (HTTP) or 443 (HTTPS)'/>
                </WrappedField>
                <WrappedField label='MDN Required'>
                    <MuiTextField style={{flex: '1'}} disabled value='Synchronous MDN'/>
                </WrappedField>
                <WrappedField label='Message Type'>
                    <MuiTextField style={{flex: '1'}} disabled value='SMIME'/>
                </WrappedField>
                <WrappedField label='Message Format'>
                    <MuiTextField style={{flex: '1'}} disabled value='Signed and encrypted'/>
                </WrappedField>
                </>}
                {isVftp(values) && <>
                <WrappedField label='Address'>
                    <MuiTextField style={{flex: '1'}} disabled value={vftpAddress}/>
                </WrappedField>
                </>}
                </div>}
                </div>
        </DialogContent>
        <DialogActions>
            <Button variant='text' color='primary' onClick={() => testLocation(values)} disabled={!(values.Destination && values.Destination.Protocol) || invalid}>Test Connection</Button>
            <DownloadButton variant='text' color='primary' onClick={handleSubmit} disabled={pristine || invalid}>Save</DownloadButton>
        </DialogActions>
        </form>)}/>
    </Dialog>;
}

type DocumentConfigurationsProps = {
    env?: any;
    partners: any[];
    documents: any[];
    save: (property: string, entry: any, index?: number | null) => Promise<boolean | undefined>;
};

type DocumentConfigurationsState = {
    showEdit: boolean;
    showConfirm: boolean;
    confirmMessage?: string;
    confirmAction?: () => void;
    formIndex?: number | null;
    formValue?: any;
};

const DocumentConfigurations = (props: DocumentConfigurationsProps) => {
    const [state, setState] = useState<DocumentConfigurationsState>({showEdit: false, showConfirm: false});
    const setStatePartial = (partial: Partial<DocumentConfigurationsState>) => setState(prev => ({...prev, ...partial}));

    const remove = async (fields: any, index: number, confirm?: boolean) => {
        if(!confirm){
            setStatePartial({showConfirm: true, confirmMessage: 'Are you sure you want to remove this document configuration?', confirmAction: () => remove(fields, index, true)});
            return;
        }
        await props.save('Documents', null, index);
    }
    const saveDocument = async (doc: any) => {
        let saved = await props.save('Documents', doc, state.formIndex);
        if(saved){
            setStatePartial({showEdit: false});
        }
    }

    let dialogProps = {env: props.env, partners: props.partners};
    let {documents} = props;
    return <Grid size={12}>
    <Card>
        <Toolbar className='lbtoolbar'>My Custom Document Settings</Toolbar>
        <div style={{padding: '1em', textAlign: 'left'}}>
            <Button onClick={() => setStatePartial({showEdit: true, formIndex: null, formValue: {}})} variant='outlined'>Add a document setting override</Button>
        </div>
        <Table>
        <TableHead>
            <TableRow>
                <TableCell>Partner</TableCell>
                <TableCell style={{width: '10em', textAlign: 'center'}}>Document Type</TableCell>
                <TableCell style={{width: '8em', textAlign: 'center', padding: 0}}>Version</TableCell>
                <TableCell style={{width: '8em', textAlign: 'center', padding: 0}}>Type Code</TableCell>
                <TableCell style={{width: '8em', minWidth: '8em', textAlign: 'center', padding: 0}}></TableCell>
                <TableCell style={{width: '195px', minWidth: '195px', padding: 0}}></TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
        {documents.map((doc: any, index: number) => (
            <TableRow key={index}>
                <TableCell>{(props.partners.find((r: any) => r.value === Number(doc.PartnerCoId)) || {}).label || doc.PartnerCoId || 'Any Partner'}</TableCell>
                <TableCell style={{textAlign: 'center'}}>{(documentTypes.find(r => r.value === doc.DocumentType) || {}).label || 'Any Type'}</TableCell>
                <TableCell style={{textAlign: 'center', padding: 0}}>{doc.Version}</TableCell>
                <TableCell style={{textAlign: 'center', padding: 0}}>{doc.TypeCode}</TableCell>
                <TableCell style={{textAlign: 'center', padding: 0}}>{doc.Default ? <DefaultChip/> : ''}</TableCell>
                <TableCell style={{textAlign: 'center', padding: 0}}>
                    <div>
                        <Button variant='outlined' style={{marginRight: '1em'}} onClick={() => setStatePartial({showEdit: true, formIndex: index, formValue: doc})}>Edit</Button>
                        <Button variant='outlined' disabled={doc.Default} onClick={() => remove(doc, index)}>Remove</Button>
                    </div>
                </TableCell>
            </TableRow>
        ))}
        </TableBody>
    </Table>
    {documents.length === 0 && <div style={{marginTop: '0.5em'}}><Typography>There are no custom document settings.</Typography></div>}
    </Card>
    <DocumentDialog {...dialogProps} open={state.showEdit} onClose={() => setStatePartial({showEdit: false})} title={`Edit Document Settings`} value={state.formValue} onChange={saveDocument}/>
    <ConfirmDialog open={state.showConfirm} onClose={() => setStatePartial({showConfirm: false})} message={state.confirmMessage} onConfirm={state.confirmAction}/>
</Grid>;
}

type DocumentDialogProps = {
    value: any;
    open: boolean;
    onClose: () => void;
    partners: any[];
    onChange: (values: any) => void;
    // Passed by DocumentConfigurations but never read here (pre-existing;
    // the toolbar title below is hardcoded). Kept in the props type so the
    // call site's extra attribute doesn't need to change.
    title?: any;
    env?: any;
};

const DocumentDialog = (props: DocumentDialogProps) => {
    let {value, open, onClose, partners} = props;
    return <Dialog maxWidth="sm" fullWidth open={open} onClose={onClose}>
        <Toolbar className='lbtoolbar'>My Custom Document Settings</Toolbar>
        <Form onSubmit={props.onChange} initialValues={value} render={({ handleSubmit, pristine, invalid, values, submitting, form: {mutators, getState} }: any) => (
          <form autoComplete='off' onSubmit={handleSubmit}>
        <DialogContent>
            <Typography style={{color: '#EE3224'}}>These settings are not common with the average EDI setup and may require further review. For more information on document settings, see <a href="https://help.logicbroker.com/hc/en-us/articles/19235164722964-Custom-Document-Settings" target='_blank' rel="noopener noreferrer">here</a>.</Typography>
            <PartnerSelector name='PartnerCoId' options={partners}/>
            <DocumentTypeSelector name='DocumentType'/>
            <WrappedField label='Version'>
                <Field style={{flex: 1}} name='Version' component={TextField} placeholder='4010'/>
            </WrappedField>
            <WrappedField label='Type'>
            <Field style={{flex: 1}} name='Type' component={TextField} placeholder='e.g. PO'/>
            </WrappedField>
            <WrappedField label='Type Code'>
                <Field style={{flex: 1}} name='TypeCode' component={TextField} placeholder='e.g. 850'/>
            </WrappedField>
            <WrappedField label='Request 997'>
                <Field style={{flex: 1}} name='RequestAck' component={TextField} placeholder='0'/>
            </WrappedField>
            <WrappedField label='Segment Terminator'>
            <Field style={{flex: 1}} name='SegmentTerminator' component={TextField} placeholder='~'/>
            </WrappedField>
            <WrappedField label='Repeat Character'>
                <Field style={{flex: 1}} name='RepeatCharacter' component={TextField} placeholder='U'/>
            </WrappedField>
            <WrappedField label='Element Separator'>
                <Field style={{flex: 1}} name='ElementSeparator' component={TextField} placeholder='*'/>
            </WrappedField>
            <WrappedField label='Sub-Element Separator'>
                <Field style={{flex: 1}} name='SubElementSeparator' component={TextField} placeholder='>'/>
            </WrappedField>
            <WrappedField label='Your ISA Qualifier'>
                <Field style={{flex: 1}} name='IsaQualifier' component={TextField}/>
            </WrappedField>
            <WrappedField label='Your ISA ID'>
                <Field style={{flex: 1}} name='IsaIdentifier' component={TextField}/>
            </WrappedField>
            <WrappedField label='Your GS ID'>
                <Field style={{flex: 1}} name='GsIdentifier' component={TextField}/>
            </WrappedField>
            <WrappedField label='Partner ISA Qualifier'>
                <Field style={{flex: 1}} name='SenderIsaQualifier' component={TextField}/>
            </WrappedField>
            <WrappedField label='Partner ISA ID'>
                <Field style={{flex: 1}} name='SenderIsaIdentifier' component={TextField}/>
            </WrappedField>
            <WrappedField label='Partner GS ID'>
                <Field style={{flex: 1}} name='SenderGsIdentifier' component={TextField}/>
            </WrappedField>
        </DialogContent>
        <DialogActions>
            <DownloadButton variant='text' color='primary' onClick={handleSubmit} disabled={pristine || invalid}>Save</DownloadButton>
        </DialogActions>
        </form>)}/>
    </Dialog>;
}

const defaultDocument = {Default: true, PartnerCoId: null, DocumentType: null, Version: '4010'};
const defaultLocation = {Default: true, PartnerCoId: null, DocumentType: null, Enabled: true};

// Constant filters for the EDI change log / transmission failure tables.
// Kept at module scope so their identity is stable across renders (these
// were instance fields on the former class component).
const auditFilter = {filters: [
    {field: "CustomerViewable", operator: 'eq', value: true},
    {field: "EventTypeId", operator: 'eq', value: 73},
    {field: "Category", operator: 'eq', value: 'EDI'}
], logic: 'and'};
const eventFilter = {filters: [
    {field: "CustomerViewable", operator: 'eq', value: true},
    {field: "EventTypeId", operator: 'eq', value: 21}
], logic: 'and'};

// EdiSettings backs a large multi-panel settings page (identifiers,
// certificates, network locations, document overrides, connection tester)
// where nearly every handler adds its own transient state keys well beyond
// the initial state literal below. Typed `any` throughout rather than
// enumerating every field (same approach as payment.tsx's PaymentSettings
// and reports.tsx's Chart/Widget).
const EdiSettings = (props: any) => {
    const [state, setState] = useState<any>(() => ({showError: false, showConfirm: false, showTest: false, config: {Documents: [], NetworkLocations: []}, certificates: [],
    testSenderQualifier: 'ZZ', testSenderIdentifier: 'TEST123', fileContent: '', testReceiverQualifier: 'ZZ', testReceiverIdentifier: 'TEST123', date: moment(),
    showAs2Upload: false, showIdEdit: false, loaded: false}));
    const setStatePartial = (partial: any) => setState((prev: any) => ({...prev, ...partial}));
    // Assigned to the hidden file input below and invoked by the "Upload a
    // test file" button.
    const sampleImportRef = useRef<any>(null);

    const loadCertificates = async () => {
        let certificates = (await axios.get(Config.api + '/odata/Company/As2Certificates?$select=Id,ExpirationDate,Thumbprint,Name')).data.value;
        let certificateOptions = certificates.map((r: any) => ({label: r.Thumbprint, value: r.Name}));
        setState((prev: any) => ({...prev, certificates, certificateOptions, refreshCerts: !prev.refreshCerts}));
    }
    const loadEdiConfig = async () => {
        let config = (await axios.get(Config.api + `/odata/Company/Functions.GetEDIConfiguration`)).data;
        (config.NetworkLocations || []).forEach((loc: any) => {
            winscpFormatter(loc, "Destination");
        });
        if(config.NetworkLocations.filter((r: any) => !r.PartnerCoId && !r.DocumentType).length === 0){
            config.NetworkLocations = [{...defaultLocation}, ...config.NetworkLocations];
        }
        if(config.Documents.filter((r: any) => !r.PartnerCoId && !r.DocumentType).length === 0){
            config.Documents = [{...defaultDocument}, ...config.Documents];
        }
        setStatePartial({config});
    }
    const saveEdiConfig = async (property: string, entry: any, index?: number | null) => {
        let config = JSON.parse(JSON.stringify(state.config));
        if(index != null){
            config[property][index] = entry;
        } else {
            config[property].push(entry);
        }
        (config.NetworkLocations || []).forEach((loc: any) => {
            winscpPostProcess(loc, 'Destination');
        });
        config.NetworkLocations = config.NetworkLocations.filter((r: any) => !isEqual(r, defaultLocation));
        config.Documents = config.Documents.filter((r: any) => !isEqual(r, defaultDocument));
        try{
            await axios.post(Config.api + `/odata/Company/Functions.SetEDIConfiguration`, config);
            await loadEdiConfig();
            setState((prev: any) => ({...prev, refreshLog: !prev.refreshLog}));
            return true;
        }catch(e: any){
            let errors = new Helper().getApiErrors((e.response || {}).data);
            setStatePartial({showError: true, errorMessage: errors.join('\n')});
        }
    }
    const loadCertificate = async (files: any) => {
        if(files && files.length > 0){
            try{
                let formData = new FormData();
                formData.append("file", files[0]);
                let ret = (await axios.post(Config.api + `/odata/company/Functions.ParseCertificate`, formData, {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    }
                })).data;
                setStatePartial({certFile: files[0], certMessage: files[0].name + "\nThumbprint: " + ret.Thumbprint + "\nExpiration: " + moment(ret.ExpirationDate).format('MM/DD/YYYY hh:mm A')});
                return true;
            }catch(e: any){
                let errors = new Helper().getApiErrors((e.response || {}).data);
                setStatePartial({certMessage: 'Certificate invalid: ' + errors.join(" ")});
            }
        }
    }
    const saveCertificate = async () => {
        let formData = new FormData();
        formData.append("file", state.certFile);
        try{
            await axios.post(Config.api + `/odata/company/As2Certificates`, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
            });
            await loadCertificates();
            setStatePartial({showAs2Upload: false});
            return true;
        }catch(e: any){
            let errors = new Helper().getApiErrors((e.response || {}).data);
            setStatePartial({showError: true, errorMessage: errors.join('\n')});
        }
    }
    const saveIdentifier = async (partnerId: any) => {
        try{
            await axios.post(Config.api + `/odata/Company/EDIPartnerIdentifiers`, partnerId);
            setState((prev: any) => ({...prev, showIdEdit: false, refreshIds: !prev.refreshIds}));
            return true;
        }catch(e: any){
            let errors = new Helper().getApiErrors((e.response || {}).data);
            setStatePartial({showError: true, errorMessage: errors.join('\n')});
        }
    }
    const deleteIdentifier = async (row: any) => {
        setStatePartial({
            showConfirm: true,
            confirmContent: `Are you sure you want to delete this identifier?`,
            handleConfirm: async () => {
                try{
                    await axios.delete(Config.api + `/odata/Company/EDIPartnerIdentifiers?id=${row.Id}`);
                    setState((prev: any) => ({...prev, showConfirm: false, refreshIds: !prev.refreshIds}));
                    return true;
                }catch(e: any){
                    let errors = new Helper().getApiErrors((e.response || {}).data);
                    setStatePartial({showError: true, errorMessage: errors.join('\n')});
                }
            }
        });
    }
    const deleteCertificate = (row: any) => {
        setStatePartial({
            showConfirm: true,
            confirmContent: `Are you sure you want to delete this certificate?`,
            handleConfirm: async () => {
                try {
                    await axios.delete(Config.api + `/odata/Company/As2Certificates?id=${row.Id}`);
                    await loadCertificates();
                    setStatePartial({showConfirm: false});
                } catch(e: any) {
                    let errors = new Helper().getApiErrors((e.response || {}).data);
                    setStatePartial({showConfirm: false, showError: true, errorMessage: errors.join('\n')});
                }
            }
        });
    }
    const testLocation = (loc: any) => {
        setState((prev: any) => {
            let testReceiverQualifier = (prev.firstId || {}).Qualifier || prev.testReceiverQualifier;
            let testReceiverIdentifier = (prev.firstId || {}).Identifier || prev.testReceiverIdentifier;
            return {...prev, testLocation: loc, showTest: true, sampleEdi: null, testLoading: false, testSuccess: false, testReportId: null, testComplete: false, testReceiverIdentifier, testReceiverQualifier};
        });
    }
    const executeLocationTest = async () => {
        let loc = {...state.testLocation};
        winscpPostProcess(loc, 'Destination');
        setStatePartial({testMessage: '', showTest: true, testLoading: true, testSuccess: false, testReportId: null, testComplete: false});
        let data = {
            Destination: loc.Destination,
            As2SenderId: loc.As2SenderId,
            As2ReceiverId: loc.As2ReceiverId,
            As2SenderCertificate: loc.As2SenderCertificate,
            As2ReceiverCertificate: loc.As2ReceiverCertificate,
            EncryptionAlgorithm: loc.As2EncryptionAlgorithm,
            SignatureAlgorithm: loc.As2SignatureAlgorithm,
            FileName: null,
            FileContent: getFileContent()
        };
        try{
            let res = (await axios.post(Config.api + '/odata/Company/Functions.TestEdiConnection', data)).data;
            if(res.Error){
                setStatePartial({testSuccess: false, testMessage: 'Test failed: ' + res.Message, testLoading: false, testReportId: res.ReportId, testComplete: true});
            } else {
                setStatePartial({testSuccess: true, testMessage: res.Message, testLoading: false, testReportId: res.ReportId, testComplete: true});
            }
        }catch(e: any){
            setStatePartial({testSuccess: false, testMessage: 'Test failed: ' + e.message, testLoading: false, testReportId: null, testComplete: true});
        }
    }
    const getFileContent = () => {
        if(state.sampleEdi){
            return state.sampleEdi;
        }
        let paddedSender = state.testSenderIdentifier.padEnd(15, ' ');
        let paddedReceiver = state.testReceiverIdentifier.padEnd(15, ' ');
        let date = state.date.format('YYYYMMDD');
        let shortDate = state.date.format('YYMMDD');
        let time = state.date.format('HHmm');
        let content = `ISA*00*          *00*          *${state.testSenderQualifier}*${paddedSender}*${state.testReceiverQualifier}*${paddedReceiver}*${shortDate}*${time}*U*00401*000000001*0*T*>~\n` +
        `GS*FA*${state.testSenderIdentifier}*${state.testReceiverIdentifier}*${date}*${time}*1*X*004010~\n` +
        "ST*997*0001~\n"+
        "AK1*PO*12345~\n"+
        "AK2*850*1006~\n"+
        "AK5*A~\n"+
        "AK9*A*1*1*1~\n"+
        "SE*6*0001~\n"+
        "GE*1*1~\n"+
        "IEA*1*000000001~\n";
        return content;
    }
    const vftpGeneratePassword = async () => {
        if(!Auth.hasPermission("api/manage")){
            setStatePartial({showConfirm: false, showError: true, errorMessage: 'API management permission is required to generate a VFTP password.'});
            return;
        }
        await axios.get(Config.api + '/odata/Company/Functions.ResetAPIKey?keyNumber=1');
        let vftpPassword = (await axios.get(Config.api + '/odata/Company/Functions.GetAPIKey?keyNumber=1')).data.value;
        setStatePartial({vftpPassword});
    }
    const uploadSample = async (files: any) => {
        if(files && files[0]){
            let content = await readFileAsync(files[0]);
            setStatePartial({sampleEdi: content});
        }
    }

    useEffect(() => {
        const init = async () => {
            if(props.setTitle) {
                props.setTitle('EDI Connection');
            }
            let partners = (await axios.get(Config.api + `/api/v1/partners`)).data.Body.Partners;
            let vftpPassword = 'API management permission required to view';
            if(Auth.hasPermission('api/manage')){
                vftpPassword = (await axios.get(Config.api + '/odata/Company/Functions.GetAPIKey?keyNumber=1')).data.value;
            }
            setStatePartial({partners: partners.map((r: any) => ({label: r.CompanyName, value: r.Id})), vftpPassword});
            await loadCertificates();
            await loadEdiConfig();
            setStatePartial({loaded: true});
        };
        init();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const renderTestDialog = () => {
        if(state.testComplete){
            return <>
            <Toolbar className='lbtoolbar'>Results</Toolbar>
            <DialogContent>
                {state.testSuccess && <div style={{textAlign: 'center'}}>
                    <Typography style={{color: 'green', fontWeight: 'bold', fontSize: '18px'}}>Connection Successful!</Typography>
                    <CheckIcon style={{color: 'green', fontSize: '110px'}}/>
                    </div>}
                {!state.testSuccess && <div style={{textAlign: 'center'}}>
                    <Typography style={{color: 'red', fontWeight: 'bold', fontSize: '18px'}}>Connection Failed!</Typography>
                    <CloseIcon style={{color: 'red', fontSize: '110px'}}/>
                    </div>}
                <Typography style={{whiteSpace: 'pre-wrap'}}>{state.testMessage}</Typography>
            </DialogContent>
            {!(!state.testReportId) && <DialogActions>
                <Button variant='outlined' color='primary' component={Link} target='_blank' to={`/settings/edi/report?reportId=${state.testReportId}`}>View Full Report</Button>
            </DialogActions>}
            </>
        } else if (state.testLoading){
            return <>
            <Toolbar className='lbtoolbar'>Testing Connection</Toolbar>
            <DialogContent>
                <LinearProgress variant='indeterminate'/>
                <Typography style={{whiteSpace: 'pre-wrap'}}>{state.testMessage}</Typography>
            </DialogContent>
            </>;
        }
        return (
            <>
            <Toolbar className='lbtoolbar'>Test Connection</Toolbar>
            <DialogContent>
                <div>
                    <MuiTextField style={{marginRight: '1em'}} label='Sender Qualifier' value={state.testSenderQualifier} onChange={(e: any) => setStatePartial({testSenderQualifier: e.currentTarget.value})} slotProps={{
                        inputLabel: {shrink: true}
                    }}/>
                    <MuiTextField label='Sender Identifier' value={state.testSenderIdentifier} onChange={(e: any) => setStatePartial({testSenderIdentifier: e.currentTarget.value})} slotProps={{
                        inputLabel: {shrink: true}
                    }}/>
                </div>
                <div>
                    <MuiTextField style={{marginRight: '1em'}} label='Receiver Qualifier' value={state.testReceiverQualifier} onChange={(e: any) => setStatePartial({testReceiverQualifier: e.currentTarget.value})} slotProps={{
                        inputLabel: {shrink: true}
                    }}/>
                    <MuiTextField label='Receiver Identifier' value={state.testReceiverIdentifier} onChange={(e: any) => setStatePartial({testReceiverIdentifier: e.currentTarget.value})} slotProps={{
                        inputLabel: {shrink: true}
                    }}/>
                </div>
                <Typography style={{marginTop: '1em'}}>Use the sample data below to test your connection or <Button variant='outlined' color='primary' style={{padding: 0}} onClick={() => sampleImportRef.current.click()}>Upload a test file</Button></Typography>
                <Typography style={{marginTop: '1em', fontWeight: 'bold'}}>File content</Typography>
                <Typography style={{marginTop: '1em', whiteSpace: 'pre', fontFamily: 'monospace', overflow: 'auto', userSelect: 'all'}}>{getFileContent()}</Typography>
                <input type="file" accept='.edi' style={{display: "none"}} ref={sampleImportRef} onChange={(e: any) => uploadSample(e.target.files)}/>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' color='primary' onClick={executeLocationTest}>Continue</Button>
            </DialogActions>
            </>
        );
    }

    let identifierConfig = {
        url: Config.api + '/odata/Company/EDIPartnerIdentifiers',
        columns: [
          { id: "Id", label: 'ID', width: '10em', hidden: true},
          { id: "PartnerCoId", label: 'Partner ID', width: '10em', hidden: true},
          { id: 'Qualifier', label: 'EDI Qualifier', filterable: true, width: '8em'},
          { id: 'Identifier', label: 'EDI ID', filterable: true},
          { id: 'PartnerName', label: 'Partner', filterable: true, getOptions: getCompanyNames, template: (val: any) => val || 'Any Partner'},
          { command: 'commands', stopPropagation: 'true', width: '195px', padding: 0, template: (value: any, row: any) => (
              <>
                <Button variant='outlined' style={{marginRight: "1em"}} onClick={() => setStatePartial({showIdEdit: true, partnerId: row})}>Edit</Button>
                <Button variant='outlined' onClick={() => deleteIdentifier(row)}>Remove</Button>
             </>
          )}
      ],
        refresh: state.refreshIds,
        order: 'asc',
        orderBy: 'PartnerName',
        keyField: 'Id',
        pageSize: 10,
        pageSizes: [10, 20, 50],
        title: 'My EDI Identifiers',
        onLoad: (data: any) => {setStatePartial({firstId: (data || [])[0]})},
        actions: <Button onClick={() => setStatePartial({showIdEdit: true, partnerId: {}})} variant='outlined'>Add my identifiers</Button>
      };
    let certificateConfig = {
        getData: () => state.certificates,
        columns: [
          { id: "Id", label: 'ID', width: '10em', hidden: true},
          { id: 'Thumbprint', label: 'Thumbprint', filterable: true},
          { id: 'ExpirationDate', label: 'Expiration Date', filterable: true, type: 'date', template: (value: any) => (<Moment format='MM/DD/YYYY hh:mm A'>{value}</Moment>)},
          { command: 'commands', stopPropagation: 'true', width: '240px', padding: 0, template: (value: any, row: any) => (
              <>
                <DownloadButton variant='outlined' style={{marginRight: "1em"}} href={Config.api + `/odata/Company/Functions.DownloadAs2Certificate?id=${row.Id}`} fileName={`${row.Thumbprint}.cer`}>Download</DownloadButton>
                <Button variant='outlined' onClick={() => deleteCertificate(row)}>Remove</Button>
             </>
          )}
      ],
        order: 'asc',
        orderBy: 'ExpirationDate',
        keyField: 'Id',
        pageSize: 10,
        pageSizes: [10, 20, 50],
        title: 'My AS2 Certificates',
        refresh: state.refreshCerts,
        actions: <div style={{textAlign: 'left'}}>
        <Typography style={{marginBottom: '0.5em'}}>This section is only applicable to users with an AS2 connection method.</Typography>
        <Button onClick={() => setStatePartial({showAs2Upload: true, certFile: null, certMessage: null})} variant='outlined'>Add a new AS2 certificate</Button>
        </div>
      };
    let specConfig = {
        url: Config.api + '/odata/Company/EDIPartnerSpecs',
        columns: [
          { id: "PartnerCoId", label: 'ID', width: '4em', hidden: true},
          { id: 'PartnerName', label: 'Partner', width: '9em', filterable: true},
          { id: 'Identifier', label: 'Qualifier:Identifier', filterable: true, width: '6em'},
          { id: 'SpecLink', label: 'Specifications', filterable: true, width: '6em', template: (val: any) => val ? <a href={val} target='_blank' rel='noopener noreferrer'>View</a> : ''}
      ],
        order: 'asc',
        orderBy: 'PartnerName',
        keyField: 'PartnerCoId',
        pageSize: 10,
        pageSizes: [10, 20, 50],
        title: Config.production ? 'Your Partner\'s EDI Connection Details' : 'Your Partner\'s Test EDI Connection Details',
        actions: <Typography>To add a new partner, please reach out to support@logicbroker.com.</Typography>
      };
      if(!state.loaded){
        return <Grid container spacing={2}>
            {!Config.production && <Grid size={12}>
                <ContentLoader preserveAspectRatio='none' style={{height: '4em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
            </Grid>}
        <Grid size={{ md: 8, sm: 12, xs: 12 }}>
            <Grid container spacing={2}>
                <Grid size={12}>
                    <ContentLoader preserveAspectRatio='none' style={{height: '10em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
                </Grid>
                <Grid size={12}>
                    <ContentLoader preserveAspectRatio='none' style={{height: '10em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
                </Grid>
                <ContentLoader preserveAspectRatio='none' style={{height: '10em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
                <ContentLoader preserveAspectRatio='none' style={{height: '10em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
            </Grid>
        </Grid>
        <Grid size={{ md: 4, sm: 12, xs: 12 }} style={{height: 'fit-content'}}>
            <Grid container spacing={2}>
                <Grid size={12}>
                    <ContentLoader preserveAspectRatio='none' style={{height: '20em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
                </Grid>
                <Grid size={12}>
                    <ContentLoader preserveAspectRatio='none' style={{height: '20em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
                </Grid>
            </Grid>
        </Grid>
        <Grid size={12}>
            <ContentLoader preserveAspectRatio='none' style={{height: '7em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
        </Grid>
        <Grid size={12}>
            <ContentLoader preserveAspectRatio='none' style={{height: '7em', width: '100%'}} primaryColor='#e1e1e1' secondaryColor='#d8d8d8'/>
        </Grid>
        </Grid>
      };
    return <Grid container spacing={2}>
        {!Config.production && <Grid size={12}>
                <Card style={{backgroundColor: "#fffaed", textAlign: "left"}}>
                    <CardContent>
                        <Typography style={{color: "rgb(223 161 0)"}}><Warning style={{verticalAlign: "middle"}}/> These settings will only be applied to your stage environment. You will need to configure a separate EDI connection in production.</Typography>
                    </CardContent>
                </Card>
            </Grid>}
        <Grid size={{ md: 8, sm: 12, xs: 12 }}>
            <Grid container spacing={2}>
                <Grid size={12}>
                    <EnhancedTable config={identifierConfig}/>
                </Grid>
                <Grid size={12}>
                    <EnhancedTable config={certificateConfig}/>
                </Grid>
                <NetworkLocations vftpPassword={state.vftpPassword} vftpGeneratePassword={vftpGeneratePassword} testLocation={testLocation} certificates={state.certificateOptions} locations={state.config.NetworkLocations} partners={state.partners} save={saveEdiConfig}/>
                <DocumentConfigurations documents={state.config.Documents} partners={state.partners} save={saveEdiConfig}/>
            </Grid>
        </Grid>
        <Grid size={{ md: 4, sm: 12, xs: 12 }} style={{height: 'fit-content'}}>
            <Grid container spacing={2}>
                <Grid size={12}>
                    <EnhancedTable config={specConfig}/>
                </Grid>
                <Grid size={12}>
                    <Card>
                    <Toolbar className='lbtoolbar'>Resource Center</Toolbar>
                        <List style={{ padding: 0 }}>
                            <ListItem {...({button: true} as any)} component='a' href='https://help.logicbroker.com/hc/en-us/articles/20332257867540' target='_blank' rel='noopener noreferrer'>
                                <ListItemText style={{ color: 'rgba(0, 0, 0, 0.87)' }} primary='How to set up my EDI connection' secondary={`Review the steps needed to set up your EDI connection and collect your partner's EDI details.`} />
                                <ArrowForwardIosIcon color="action" />
                            </ListItem>
                            <ListItem {...({button: true} as any)} component='a' href='https://help.logicbroker.com/hc/en-us/articles/360022067631-SFTP-FTP' target='_blank' rel='noopener noreferrer'>
                                <ListItemText style={{ color: 'rgba(0, 0, 0, 0.87)' }} primary='SFTP/FTP' secondary='See how to connect using our Logicbroker-hosted SFTP or your own SFTP/FTP and take a look at the directories.' />
                                <ArrowForwardIosIcon color="action" />
                            </ListItem>
                            <ListItem {...({button: true} as any)} component='a' href='https://help.logicbroker.com/hc/en-us/articles/19235164722964-Custom-Document-Settings' target='_blank' rel='noopener noreferrer'>
                                <ListItemText style={{ color: 'rgba(0, 0, 0, 0.87)' }} primary='Custom document settings' secondary='Review what document settings may pertain to you and how to configure them in the portal.' />
                                <ArrowForwardIosIcon color="action" />
                            </ListItem>
                        </List>
                    </Card>
                </Grid>
            </Grid>
        </Grid>
        <Grid size={12}>
            <EventTable title="EDI Change Log" filter={auditFilter} refresh={state.refreshLog}/>
        </Grid>
        <Grid size={12}>
            <EventTable title="EDI Transmission Failures" filter={eventFilter} refresh={state.refreshLog} includeDocLink/>
        </Grid>
        <Dialog open={state.showError} onClose={() => {setStatePartial({showError: false})}}>
            <Toolbar className='lbtoolbar'>Error</Toolbar>
            <DialogContent><Typography>{state.error}</Typography></DialogContent>
        </Dialog>
        <Dialog maxWidth="sm" open={state.showTest} onClose={() => setStatePartial({showTest: false})} fullWidth>
            {renderTestDialog()}
        </Dialog>
        <Dialog maxWidth="sm" fullWidth open={state.showIdEdit} onClose={() => setStatePartial({showIdEdit: false, partnerId: {}})}>
            <Toolbar className='lbtoolbar'>My EDI Identifier</Toolbar>
            <Form onSubmit={saveIdentifier} initialValues={state.partnerId} render={({ handleSubmit, pristine, invalid, values, submitting }: any) => (
            <form autoComplete='off' onSubmit={handleSubmit}>
            <DialogContent>
                <WrappedField label='Qualifier'>
                    <Field style={{flex: 1}} name='Qualifier' component={TextField}/>
                </WrappedField>
                <WrappedField label='Identifier'>
                    <Field style={{flex: 1}} name='Identifier' component={TextField}/>
                </WrappedField>
                <PartnerSelector name='PartnerCoId' options={state.partners}/>
            </DialogContent>
            <DialogActions>
                <DownloadButton variant='outlined' color='primary' onClick={handleSubmit} disabled={pristine || invalid}>Save</DownloadButton>
            </DialogActions>
            </form>)}/>
        </Dialog>
        <Dialog maxWidth="sm" fullWidth open={state.showAs2Upload} onClose={() => setStatePartial({showAs2Upload: false})}>
            <Toolbar className='lbtoolbar'>Add an AS2 Certificate</Toolbar>
            <DialogContent style={{overflow: 'hidden'}}>
                <Typography>Once you add an AS2 certificate, you'll need to configure it to your EDI connection. </Typography>
                <DropZone accept=".cer,.crt" style={{width: '100%', height: '10em', marginTop: '1em'}} onDrop={loadCertificate}>
                {({ isDragAccept, isDragReject, acceptedFiles, rejectedFiles }: any) => {
                    if (isDragAccept || isDragReject) {
                      return "Drop here to upload this file.";
                    }
                    if(rejectedFiles && rejectedFiles.length > 0){
                        return "File type is invalid. Please upload a .cer or .crt file.";
                    }
                    return state.certMessage ? <div style={{whiteSpace: "pre-wrap"}}>{state.certMessage}</div> : 'Drop an AS2 certificate here or click to choose a file.';
                  }}
                </DropZone>
            </DialogContent>
            <DialogActions>
                <DownloadButton variant='outlined' color='primary' onClick={saveCertificate} disabled={!state.certFile}>Save</DownloadButton>
            </DialogActions>
        </Dialog>
          <ErrorDialog open={state.showError} message={state.errorMessage} onClose={() => setStatePartial({showError: false})}/>
          <ConfirmDialog open={state.showConfirm} onClose={() => setStatePartial({showConfirm: false})} message={state.confirmContent} onConfirm={state.handleConfirm}/>
    </Grid>;
}

export default EdiSettings;
